<h2 mat-dialog-title style="margin: 0 0 20px; display: flex; justify-content: space-between; align-items: center">
  <span>Select</span>
  <button type="button" mat-icon-button matTooltip="Close" (click)="closeDialog()">
    <i class="fas fa-times"></i>
  </button>
</h2>
<mat-dialog-content>
  <div style="display: flex; align-items: flex-end; justify-content: space-between; gap: 16px; margin-bottom: 12px">
    <mat-form-field subscriptSizing="dynamic" style="width: 200px; flex: 0 0 auto">
      <input
        matInput
        placeholder="Search by ID"
        matTooltip="Type or paste an ID to fetch it directly from the server"
        [ngModel]="searchTerm"
        (ngModelChange)="onSearchInput($event)" />
      @if (loading) {
        <mat-spinner matSuffix [diameter]="16"></mat-spinner>
      }
    </mat-form-field>
    @if (response) {
      <mat-paginator
        class="lookup-paginator"
        [length]="response.total"
        [pageSize]="response.perPage"
        [pageIndex]="response.offset"
        [pageSizeOptions]="[20, 50, 100, 200]"
        [showFirstLastButtons]="true"
        (page)="pageChanged($event)">
      </mat-paginator>
    }
  </div>
  @if (loading) {
    <div>
      <mat-spinner [diameter]="24" style="margin: auto"></mat-spinner>
    </div>
  }
  @if (!loading && dataSource && dataSource.data.length === 0) {
    <div>No results found.</div>
  }
  @if (!loading && dataSource && dataSource.data.length > 0) {
    <table mat-table [dataSource]="dataSource" style="width: 100%">
      @for (field of allFields; track field.name) {
        <ng-container matColumnDef="{{ field.name }}">
          <th mat-header-cell *matHeaderCellDef>{{ field.label }}</th>
          <td mat-cell *matCellDef="let element">
            <app-table-cell [type]="field.type" [data]="element[field.name]" [fieldConfig]="field"></app-table-cell>
          </td>
        </ng-container>
      }
      <tr mat-header-row *matHeaderRowDef="displayedFieldsNames"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedFieldsNames; let i = index"
        (click)="onRowClick(row)"
        class="maintain-row"
        [attr.data-id]="'listItem' + i"></tr>
    </table>
  }
</mat-dialog-content>
